import { render, staticRenderFns } from "./related.vue?vue&type=template&id=410b618c&scoped=true&"
import script from "./related.vue?vue&type=script&lang=js&"
export * from "./related.vue?vue&type=script&lang=js&"
import style0 from "./related.vue?vue&type=style&index=0&id=410b618c&lang=scss&scoped=true&"
import style1 from "./related.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410b618c",
  null
  
)

export default component.exports